import ArtistAccountTabs from "@/components/ArtistAccountTabs";
import ProfileImage from "@/components/ProfileImage";
import { Box, Card, Container, Stack, Typography } from "@mui/material";
import ArtworkImage from "./ArtworkImage";
import CoverImage from "./CoverImage";
import EditCommunity from "./EditCommunity";
import EditInstagram from "./EditInstagram";
import EditName from "./EditName";
import EditSpotify from "./EditSpotify";
import EditTikTok from "./EditTikTok";
import EditWelcomeSms from "./EditWelcomeSms";
import PageAppBar from "./PageAppBar";

import PreviewContainer from "./PreviewContainer";
export default function ArtistProfile() {
  return (
    <Box>
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <ArtistAccountTabs />
        <PageAppBar />

        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <ProfileImage />
          <EditName />
        </Stack>

        {/* <CopyArtistLink /> */}

        <Stack direction="row" sx={{ my: 4 }}>
          <CoverImage />
          <ArtworkImage />
        </Stack>

        <Stack direction="column" spacing={4} sx={{ my: 4 }}>
          <EditSpotify />
          <EditInstagram />
          <EditTikTok />
          <EditCommunity />
        </Stack>

        <PreviewContainer />

        <Card sx={{ p: 3, borderRadius: "25px", mt: 4 }}>
          <Typography variant="h6">Welcome SMS</Typography>
          <Typography variant="caption" color="text.secondary">
            Sent as SMS to fans when they subscribe.
          </Typography>
          <EditWelcomeSms />
        </Card>
      </Container>
    </Box>
  );
}
